module.exports = "/images/vendor/blueimp-gallery/error.svg?4aa1fd4422f6bf72d650725d73915b60";